import { render, staticRenderFns } from "./StadiumDashboard.vue?vue&type=template&id=1610305e&"
import script from "./StadiumDashboard.vue?vue&type=script&lang=js&"
export * from "./StadiumDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1610305e')) {
      api.createRecord('1610305e', component.options)
    } else {
      api.reload('1610305e', component.options)
    }
    module.hot.accept("./StadiumDashboard.vue?vue&type=template&id=1610305e&", function () {
      api.rerender('1610305e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/StadiumDashboard.vue"
export default component.exports